module.exports = __webpack_public_path__ + "static/media/bear.02f19783.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profile-icons/bear.svg
// module id = 1112
// module chunks = 31